import { useState } from 'react';
import { colorFormatTag, formatTag } from '../../../../utils/constant';
import { createPortal } from 'react-dom';
export default function TagHover({ tags }) {
	const [show, setShow] = useState(false);
	const [position, setPosition] = useState({ top: 0, left: 0 });

	const handleEnter = (e) => {
		const rect = e.currentTarget.getBoundingClientRect();
		setPosition({
			top: rect.bottom + window.scrollY + 4,
			left: rect.left + window.scrollX,
		});
		setShow(true);
	};

	return (
		<>
			<span
				style={{
					backgroundColor: '#4C51BF',
					color: '#fff',
					borderRadius: '6px',
					padding: '2px 8px',
					fontSize: '11px',
					marginLeft: '6px',
					cursor: 'pointer',
				}}
				onMouseEnter={handleEnter}
				onMouseLeave={() => setShow(false)}
			>
				+{tags.length}
			</span>

			{show &&
				createPortal(
					<div
						className=""
						style={{
							position: 'absolute',
							top: position.top,
							left: position.left,
							borderRadius: '8px',
							zIndex: 9999999,
							minWidth: '180px',
						}}
					>
						{tags.map((tag, i) => (
							<div
								key={i}
								style={{
									padding: '6px 8px',
									marginBottom: '4px',
									borderRadius: '6px',
									backgroundColor: colorFormatTag(tag),
									fontSize: '12px',
								}}
							>
								{formatTag(tag)}
							</div>
						))}
					</div>,
					document.body,
				)}
		</>
	);
}
